<template>
    <b-overlay
        :show="status.isWaiting"
        variant="light"
        spinner-variant="primary"
    >
        <div class="bg-white rounded">
            <b-row class="justify-content-lg-center">
                <b-col>
                    <b-table id="productsTable" class="mb-1" responsive outlined borderless striped hover show-empty :empty-text="$t('app_table_empty_text')" :items="products.products" :fields="fields" :per-page="perPage" :current-page="currentPage">
                        <template v-slot:head(name)>
                            {{ $t('product_label_name') }}
                        </template>
                        <template v-slot:head(code)>
                            {{ $t('product_label_product_code') }}
                        </template>
                        <template v-slot:head(price)>
                            {{ $t('product_label_price') }}
                        </template>
                        <template v-slot:head(discount)>
                            {{ $t('product_label_discount') }}
                        </template>
                        <template v-slot:head(vat)>
                            {{ $t('product_label_vat') }}
                        </template>
                        <template v-slot:head(isActive)>
                            {{ $t('product_label_is_active') }}
                        </template>
                        <template v-slot:head(actions)>
                            {{ $t('product_label_actions') }}
                        </template>
                        <template v-slot:cell(code)="{ item }">
                            {{ item.code ? item.code : '-' }}
                        </template>
                        <template v-slot:head(unit)>
                            {{ $t('product_label_unit') }}
                        </template>
                        <template v-slot:cell(price)="{ item }">
                            {{ item.price.toFixed(2) }} ({{ item.currency }})
                        </template>
                        <template v-slot:cell(discount)="{ item }">
                            {{ item.discount }} %
                        </template>
                        <template v-slot:cell(vat)="{ item }">
                            {{ item.vat }} %
                        </template>
                        <template v-slot:cell(isActive)="{ item }">
                            {{ item.isActive ? $t('app_yes') : $t('app_no') }}
                        </template>
                        <template v-slot:cell(unit)="{ item }">
                            {{ translateUnit(item.unit) }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <a :href="`/product/${item.apiId}`" type="button" class="btn btn-sm btn-info" :disabled="item.isActive">{{ $t('product_button_view') }}</a>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <b-row class="justify-content-lg-center pl-2 pr-2">
                <b-col>
                    <label>
                        <small><b>{{ $t('app_table_label_per_page') }}</b></small>
                        <b-form-select size="sm" v-model="perPage" :options="perPageOptions" />
                    </label>
                </b-col>
                <b-col class="d-flex">
                    <b-pagination class="my-auto ml-auto" align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="productsTable" /> 
                </b-col>
            </b-row>
        </div>
		<b-row class="justify-content-lg-center" v-if="checkRole(user, 'ROLE_ADMIN')">
			<b-col>
                <hr />
                <button type="button" class="btn btn-success" @click="productsSync" :disabled="syncDisabled">{{ $t('product_button_sync') }}</button>
			</b-col>
		</b-row>

		<b-modal 
            v-if="checkRole(user, 'ROLE_ADMIN')"
            ref="syncModal" 
            size="md" 
            :title="$t('product_sync_modal_title')" 
            ok-only
            :ok-title="$t('product_sync_modal_button_ok')"
            @hidden="closeSyncModal"
        >
            <b-list-group v-if="products && products.sync">
                <b-list-group-item>{{ $t('product_sync_created') }}: {{ products.sync.created }}</b-list-group-item>
                <b-list-group-item>{{ $t('product_sync_updated') }}: {{ products.sync.updated }}</b-list-group-item>
                <b-list-group-item>{{ $t('product_sync_deactivated') }}: {{ products.sync.deactivated }}</b-list-group-item>
            </b-list-group>
		</b-modal>
    </b-overlay>
</template>

<script>
export default {
    name: 'ProductIndex',
    props: [
        'user',
        'checkRole',
        'products',
        'status',
        'syncProductsCall',
        'syncDisabled',
        'showSyncModal',
        'closeSyncModal',
        'translateUnit',
    ],
    data() {
        return {
            perPageOptions: [ 5, 10, 25, 50, 100 ],
            perPage: 25,
            currentPage: 1,
            fields: [
                { key: 'name', sortable: true },
                { key: 'code', sortable: true },
                { key: 'unit', sortable: true },
                //{ key: 'price', sortable: true },
                //{ key: 'discount', sortable: true },
                //{ key: 'vat', sortable: true },
                { key: 'isActive', sortable: true },
                { key: 'actions', sortable: false },
            ],
        }
    },
    computed: {
        rows() {
            return this.products && this.products.products ? this.products.products.length : 0;
        }
    },
    methods: {
        productsSync() {
            this.syncProductsCall();
        },
    },
	watch: {
        showSyncModal() {
            if (this.showSyncModal) {
                this.$refs['syncModal'].show();
            }
        },
	},
}
</script>
